<template>
    <div>
      <h2 class="text-2xl font-bold mb-4">🔥 Productos Más Vendidos</h2>
  
      <div class="flex items-center gap-4 mb-4">
        <label>Desde:</label>
        <input type="date" v-model="desde" class="border p-2 rounded" />
        <label>Hasta:</label>
        <input type="date" v-model="hasta" class="border p-2 rounded" />
        <button @click="cargarProductos" class="bg-blue-600 text-white px-4 py-2 rounded">Buscar</button>
      </div>
  
      <table v-if="resumen.length" class="w-full table-auto text-sm border">
        <thead class="bg-gray-100">
          <tr>
            <th class="p-2 border">Producto</th>
            <th class="p-2 border">Cantidad Vendida</th>
            <th class="p-2 border">Total Generado</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in resumen" :key="item.id">
            <td class="p-2 border">{{ item.nombre }}</td>
            <td class="p-2 border">{{ item.cantidad }}</td>
            <td class="p-2 border font-bold">${{ item.total.toFixed(2) }}</td>
          </tr>
        </tbody>
      </table>
  
      <div v-else class="text-gray-500 mt-6">No hay productos vendidos en este rango.</div>
    </div>
  </template>
  
  <script setup>
  import { ref } from 'vue'
  import { db } from '@/firebase'
  import { collection, query, where, getDocs, Timestamp } from 'firebase/firestore'
  
  const desde = ref('')
  const hasta = ref('')
  const resumen = ref([])
  
  const cargarProductos = async () => {
    if (!desde.value || !hasta.value) return alert('Selecciona fechas')
  
    const desdeTS = Timestamp.fromDate(new Date(desde.value + 'T00:00:00'))
    const hastaTS = Timestamp.fromDate(new Date(hasta.value + 'T23:59:59'))
  
    const q = query(
      collection(db, 'ventas'),
      where('fecha', '>=', desdeTS),
      where('fecha', '<=', hastaTS)
    )
  
    const snap = await getDocs(q)
  
    const mapaProductos = {}
  
    snap.forEach(doc => {
      const venta = doc.data()
      if (venta.productos) {
        venta.productos.forEach(p => {
          if (!p.tipo || p.tipo === 'producto') {
            if (!mapaProductos[p.id]) {
              mapaProductos[p.id] = {
                id: p.id,
                nombre: p.nombre,
                cantidad: 0,
                total: 0
              }
            }
            mapaProductos[p.id].cantidad += p.cantidad
            mapaProductos[p.id].total += p.precio * p.cantidad
          }
        })
      }
    })
  
    resumen.value = Object.values(mapaProductos).sort((a, b) => b.cantidad - a.cantidad)
  }
  </script>
  